import { render } from "./CardsFrame.vue?vue&type=template&id=89ea31e2"
import script from "./CardsFrame.vue?vue&type=script&lang=js"
export * from "./CardsFrame.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\tink\\tink-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__